import React from 'react';

import { buildMatchResultStatRows } from './utils/matchResultModalStats';

const getValueToneClassName = (rowTone) => {
  if (rowTone === 'secondary') {
    return 'muted';
  }

  if (rowTone === 'highlight') {
    return 'gold';
  }

  return '';
};

export default function TrainingMatchResultModal({
  visible,
  data,
  onNextLeg,
  onFinish,
  onRematch,
}) {
  if (!visible || !data) return null;

  const { winner, isMatchOver, playerStats } = data;
  const winnerName = playerStats[winner]?.name || 'Jugador';
  const player1Stats = playerStats[0];
  const player2Stats = playerStats[1];
  const isSoloMode = !player2Stats;
  const statRows = buildMatchResultStatRows(player1Stats, player2Stats);
  const headingKicker = isMatchOver ? 'PARTIDA COMPLETADA' : 'LEG COMPLETADO';
  const headingCopy = isMatchOver
    ? 'Resumen final del resultado y de las estadísticas más importantes de la partida.'
    : 'Revisa el marcador y el rendimiento antes de pasar al siguiente leg.';

  return (
    <div className="x01-modal-overlay">
      <div className="x01-modal x01-result-modal">
        <div className="x01-result-header">
          <img src="/Logo26.png" alt="501 Dart League" className="x01-result-logo" />
          <span className="x01-result-kicker">{headingKicker}</span>
          <h2>¡{winnerName} {isMatchOver ? 'gana la partida' : 'gana el leg'}!</h2>
          <p className="x01-result-copy">{headingCopy}</p>
        </div>

        <div className="x01-result-scoreboard">
          {playerStats.map((player, index) => (
            <div key={player.name} className={`x01-result-player ${index === winner ? 'winner' : ''}`}>
              <span className="x01-result-name">{player.name}</span>
              <span className="x01-result-legs">{player.gamesWon}</span>
              {index === winner && <span className="x01-result-crown">👑</span>}
            </div>
          ))}
        </div>

        <div className={`x01-result-stats ${isSoloMode ? 'solo' : ''}`}>
          {statRows.map((row) => {
            const valueToneClassName = getValueToneClassName(row.tone);

            if (isSoloMode) {
              return (
                <div key={row.label} className={`x01-result-stat-row solo ${row.tone === 'highlight' ? 'highlight' : ''}`}>
                  <span className={`x01-stat-label ${row.tone === 'highlight' ? 'highlight' : ''}`}>{row.label}</span>
                  <div className="x01-stat-values solo">
                    <span className={`x01-stat-value ${valueToneClassName}`.trim()}>{row.player1Value}</span>
                  </div>
                </div>
              );
            }

            return (
              <div key={row.label} className={`x01-result-stat-row compare ${row.tone === 'highlight' ? 'highlight' : ''}`}>
                <span className={`x01-stat-value ${winner === 0 ? 'highlight' : ''} ${valueToneClassName}`.trim()}>
                  {row.player1Value}
                </span>
                <span className={`x01-stat-label center ${row.tone === 'highlight' ? 'highlight' : ''}`.trim()}>
                  {row.label}
                </span>
                <span className={`x01-stat-value ${winner === 1 ? 'highlight' : ''} ${valueToneClassName}`.trim()}>
                  {row.player2Value}
                </span>
              </div>
            );
          })}
        </div>

        <div className="x01-result-actions">
          {!isMatchOver ? (
            <button className="x01-result-btn primary" onClick={onNextLeg}>
              Siguiente Leg
            </button>
          ) : (
            <>
              <button className="x01-result-btn primary" onClick={onRematch}>
                🔄 Revancha
              </button>
              <button className="x01-result-btn secondary" onClick={onFinish}>
                Salir
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}